export const enum AppEnv {
  Development = `development`,
  Production = `production`,
  Test = `test`,
}

export function getAppEnv(): string {
  return typeof APP_ENV !== `undefined` ? APP_ENV : AppEnv.Development;
}

export function isDevEnv(): boolean {
  return getAppEnv() === AppEnv.Development;
}

export function isTestEnv(): boolean {
  return getAppEnv() === AppEnv.Test;
}

export function isProdEnv(): boolean {
  return getAppEnv() === AppEnv.Production;
}

export function isBrowserEnv(): boolean {
  return typeof window !== `undefined`;
}

export function isNodeEnv(): boolean {
  return typeof global !== `undefined`;
}

export function isStandalone(): boolean {
  return typeof mp === `undefined`;
}
